<div [class.is-printing]="true">

    <div class="modal-header">
        <h4 class="modal-title">Timer og kørsel</h4>
        <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">
        <ul class="nav nav-tabs card__tabs">
            <ng-container *ngFor="let tab of tabs">
                <li *ngIf="lev >= tab.lev" class="nav-item">
                    <div [ngClass]="[step === tab.step ? 'active' : '']" (click)="gotoTab(tab)" class="nav-link">
                        {{tab.text}}
                    </div>
                </li>
            </ng-container>
        </ul>

        <div class="row my-2">
            <div class="col-10">
                <div class="btn-toolbar">
                    <ng-container *ngIf="step < 5">
                        <div *ngIf="lev < 4">Medarbejder: {{ user?.fornavn + ' ' + user?.efternavn }}</div>
                        <div *ngIf="lev >= 4" ngbDropdown class="d-inline-block">
                            <button class="btn btn-primary btn-sm btn--menu me-2" id="userSelect" ngbDropdownToggle>Medarbejder: {{ user?.fornavn + ' ' + user?.efternavn }}</button>
                            <div ngbDropdownMenu aria-labelledby="userSelect">
                                <div class="user-drop">
                                    <button
                                        *ngFor="let user of users"
                                        class="dropdown-item"
                                        [class.user--fratraadt]="user.fratraadt"
                                        (click)="onSelectUser(user)">{{ user?.fornavn + ' ' + user?.efternavn }}</button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container [formGroup]="selectedDateForm">
                        <div class="me-2">
                            <app-date-picker-dk
                                *ngIf="step === 2"
                                formControlName="selectedDate"
                            ></app-date-picker-dk>
                        </div>
                    </ng-container>
                    <div *ngIf="step !== 2" ngbDropdown class="d-inline-block">
                        <button class="btn btn-primary btn-sm btn--menu me-2" id="periodSelect" ngbDropdownToggle>År: {{ selectedYear || '- vælg -' }}</button>
                        <div ngbDropdownMenu aria-labelledby="periodSelect">
                            <button *ngFor="let year of years" class="dropdown-item" (click)="onSelectYear(year)">{{ year }}</button>
                        </div>
                    </div>
                    <div *ngIf="[1,3,5].includes(step)" ngbDropdown class="btn-group d-inline-block me-2">
                        <button type="button" class="btn btn-primary btn-sm" (click)="onWeekBack()"><</button>
                        <button class="btn btn-primary btn-sm btn--menu" id="weekSelect" ngbDropdownToggle>Uge: {{ selectedWeek || '- vælg -' }}</button>
                        <div ngbDropdownMenu aria-labelledby="weekSelect">
                            <div class="weeks-drop">
                                <button *ngFor="let week of weeksInYear" class="dropdown-item weeks-drop__button" (click)="onSelectWeek(week)">{{ week }}</button>
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary btn-sm" (click)="onWeekForward()">></button>
                    </div>
                    <button *ngIf="step !== 4" (click)="onToday()" class="btn btn--menu btn-primary btn-sm me-2" type="button">I dag</button>
                    <app-search-input
                        *ngIf="step < 4 && step !== 2"
                        [search]="searchFor"
                        (searchChange)="onSearch($event)"
                    ></app-search-input>
                </div>
            </div>

            <div class="col-2">
                <div class="btn-toolbar float-end">
                    <button *ngIf="step < 3" (click)="plannedTimeoff()" class="btn btn--menu btn-primary btn-sm me-2" type="button">Planlagt fravær</button>
                    <button *ngIf="step === 4" (click)="pdfMileage()" class="btn btn--menu btn-primary btn-sm me-2" type="button">PDF kørebog</button>
                    <button *ngIf="step === 4" (click)="paidoutMileage()" class="btn btn--menu btn-primary btn-sm me-2" type="button">Afregn</button>
                </div>
            </div>
        </div>

        <app-time-log *ngIf="step === 1"></app-time-log>
        <app-time-log-lines *ngIf="step === 2"></app-time-log-lines>
        <app-money-log *ngIf="step === 3"></app-money-log>
        <app-mileage-log *ngIf="step === 4"></app-mileage-log>
        <app-employees-done *ngIf="step === 5"></app-employees-done>
    </div>

</div>
